export default __webpack_public_path__ + "static/nodejs-b86f84250433313fa28f7166cb606f93.svg";